import { Button } from '@/components/ui/button';
/**
 * Shared error / pending / not-found boundaries (frontend-map §2.1 — FOUNDATION-owned).
 * Feature routes reference these for `errorComponent` / `pendingComponent` /
 * `notFoundComponent`.
 */
import { Link } from '@tanstack/react-router';

export function RoutePending() {
  return (
    <div className="flex items-center justify-center py-16 text-sm text-[var(--muted-foreground)]">
      Loading…
    </div>
  );
}

export function RouteError({ error }: { error: Error }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <p className="max-w-md text-sm text-[var(--muted-foreground)]">{error.message}</p>
      <Button asChild variant="outline">
        <Link to="/library">Back to Library</Link>
      </Button>
    </div>
  );
}

export function RouteNotFound() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <h2 className="text-lg font-semibold">Not found</h2>
      <p className="text-sm text-[var(--muted-foreground)]">
        That page doesn’t exist or isn’t available to you.
      </p>
      <Button asChild variant="outline">
        <Link to="/library">Back to Library</Link>
      </Button>
    </div>
  );
}
